import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ContactpersonalOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { AbstractListWidgetInner, WidgetInnerView } from 'src/app/widget-inner';
import * as globals from 'src/app/globals';
import { ContactService } from 'src/app/lib/customer/services/contact.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { FilterType, FilterTypeCriteria, FilterTypes } from 'src/app/components/edit/edit-userfilter/edit-userfilter.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateContactDialogComponent } from 'src/app/lib/customer/components/dialog/create-contact-dialog/create-contact-dialog.component';
import { showAnimation } from 'src/animations';

@Component({
  selector: 'app-contactperson-widget-inner',
  templateUrl: './contactperson-widget-inner.component.html',
  styleUrls: ['./contactperson-widget-inner.component.css'],
  animations: [ showAnimation ]
})
export class ContactpersonWidgetInnerComponent extends AbstractListWidgetInner<ContactpersonalOverviewModel> {
  
  currentView;

  currentFilterType: FilterType<number> = FilterTypes.find(x => x.value === "ContactPerson");

  viewTitle: string = null;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _contactService: ContactService,
    private _dialog: MatDialog,
    private _router: Router
  ) {
    super();
    this.sortAttribute = "contactperslname";
    this.setInitialDefaultView();

    this.stringSearchProvider = (...args) => this._contactService.searchContactsByString(...args);
    this.userFilterSearchProvider = (...args) => this._contactService.searchContactsByUserFilter(...args);
  }

  addContactperson = () => this._dialog.open(CreateContactDialogComponent, {
    panelClass: "no-padding-dialog-container",
    autoFocus: false
  });

  editContactperson(contactperson: ContactpersonalOverviewModel){
    this._router.navigate(["/contact-details", contactperson.contactpersid]);
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Neuen Ansprechpartner anlegen'),
        icon: () => of('add'),
        onClick: () => {
          this.addContactperson();
          return of(null);
        },
        color: () => of(globals.widgetAdderColor)
      } as WidgetInnerView
    ]);
  }

  setDefaultView(view) {
    this.currentView = view;
    if (view.title) this.viewTitle = view.title;
    if (view.sortAttribute) this.sortAttribute = view.sortAttribute;
    if (view.sortDsc) this.sortDsc = view.sortDsc;

    this.userFilterIdentifier = 0;

    this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => {
      return view.provider(this._contactService, page) as Observable<PaginationResponse<ContactpersonalOverviewModel[]>>;
    })));
  }

  setInitialDefaultView() {
    this.setDefaultView(ContactpersonWidgetDefaultViews[0]);
  }

  setFilter(criteria: FilterTypeCriteria<number>){
    if(criteria.value == this.sortAttribute) this.sortDsc = !this.sortDsc;
    else {
      this.sortAttribute = criteria.value;
      this.sortDsc = false;
    }
    this.sortEntries();
  }

  ContactpersonWidgetDefaultViews = ContactpersonWidgetDefaultViews;

}

export const ContactpersonWidgetDefaultViews = [
  {
    title: "Zuletzt verwendet",
    icon: "history",
    provider:  function (contactService: ContactService, page: PaginationPage): Observable<PaginationResponse<ContactpersonalOverviewModel[]>> {
      return contactService.getUserContactHistory(page);
    }
  }, {
    title: "Beobachtete Ansprechpartner",
    icon: "visibility",
    provider:  function (contactService: ContactService, page: PaginationPage): Observable<PaginationResponse<ContactpersonalOverviewModel[]>> {
      return contactService.getWatchedContacts(page);
    }
  }
];
